export default {
  main: {
    hero: `
        <strong>매력적인</strong> 캐릭터들이<br/>
        등장하는 <strong>생동감</strong><br/>
        넘치는 게임입니다
      `,
    homescapes: `집사 오스틴과 함께 아름다운 저택을 복원할 수 있는 꿈(Scapes™) 시리즈의 장대한 작품입니다`,
    township: `이벤트, 대회, PVP 토너먼트로 가득한 재미있는 도시 건설 게임`,
    xsolla: 'Xsolla is an authorized global distributor of Playrix games',
  },
  common: {
    login: '로그인',
    logout: '로그아웃',
    support: '지원',
    privacy: '개인정보보호정책',
    terms: `이용약관`,
    and: '및',
    guest: '손님',
    play: '플레이',
    install: '설치',
  },
  support: {
    title: `도움이 필요하세요?`,
    description: `저희 게임 유저로서 도움이 필요하시면
      저희가 정성껏 도와드리겠습니다.`,
    button: '@:common.support',
  },
  homescapes: {
    title: '꿈의 집',
    caption: '집사 오스틴을 도와 가족의 저택에 온기와 편안함을 되찾아주세요.',
    description: `집사 오스틴을 도와 가족의 저택에
      온기와 편안함을 되찾아주세요.
      문을 열고 들어오면 모험이 여러분을 맞이할 거예요!`,
    xsolla: 'Xsolla는 꿈의 집 공인 글로벌 유통사입니다',
    install: {
      title: '@:common.install',
      text: `이제 데스크톱에서도 꿈의 집을 플레이할 수 있어요!
      웹 버전 게임을 설치하고 오스틴을 방문하세요!`,
      button: '@:common.install',
    },
  },
  township: {
    title: '꿈의 마을',
    caption: `꿈의 마을을 건설하세요!
      작물을 수확하여 공장에서 가공하고 물건을 판매해서 마을을 발전시키세요.`,
    description: `꿈의 마을을 건설하세요!
      작물을 수확하여 공장에서 가공하고 물건을 판매해서 마을을 발전시키세요.`,
    xsolla: 'Xsolla는 꿈의 마을 공인 글로벌 유통사입니다',
    install: {
      title: '@:common.install',
      text: `데스크톱에서 Township을 즐기세요!
      웹 버전을 설치하고 몇 번의 클릭으로 마을을 방문하세요!`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: '여러분께서 웹사이트를 편하게 이용하실 수 있도록 쿠키를 사용하고 있습니다.',
    link: `더 알아보기`,
    button: '수락',
  },
  game: {
    notSupported: `모바일 기기는 지원하지 않습니다. 컴퓨터에서 로그인하여 플레이하세요.`,
  },
};
